import { render } from "./detail.vue?vue&type=template&id=3bb92e02&ts=true"
import script from "./detail.vue?vue&type=script&lang=ts&config=true"
export * from "./detail.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__